module.exports = __webpack_public_path__ + "img/error-dark.441911a5.svg";